"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { Text } from '../../../Text/Text.mjs';
import { IconCircleCheck, IconCircleMinus } from '@tabler/icons-react';
import { useLocalizedStringFormatter } from 'react-aria';
import { generateValidationTranslation } from '../../lib/generateValidationTranslation.mjs';
import locales from '../../../../../../_virtual/_.locale.json@95341064edeb0e38b66d786dbd62955c.mjs';
import styles from './ValidationResultEntry.module.scss.mjs';

const ValidationResultEntry = (props) => {
  const { result } = props;
  const translate = useLocalizedStringFormatter(locales);
  const icon = result.isValid ? /* @__PURE__ */ jsx(IconCircleCheck, { color: "green" }) : /* @__PURE__ */ jsx(IconCircleMinus, { color: "red" });
  const [translationKey, translationValues] = generateValidationTranslation(
    result,
    true
  );
  return /* @__PURE__ */ jsxs(
    Text,
    {
      className: styles.validationResultEntry,
      "data-rule": result.ruleType,
      "data-rule-valid": result.isValid,
      children: [
        icon,
        translate.format(translationKey, translationValues)
      ]
    },
    translationKey
  );
};

export { ValidationResultEntry, ValidationResultEntry as default };
//# sourceMappingURL=ValidationResultEntry.mjs.map
